import { ResponseEntityId } from 'types'

export enum SchoolQueryApiRoutes {
	BASE_URL = 'schools'
}

export interface StudentsListFilter {
	studentsIdList: ResponseEntityId[]
}
